// extracted by mini-css-extract-plugin
export var errorBanner = "_co-2";
export var scroller = "_co-0";
export var thinking = "_co-1";
export var visuallyHidden = "_co-3";